import { userRequest, BASE_URL } from "../requestMethods";

import {
  getOrderStart,
  getOrderSuccess,
  getOrderFailure,
} from "../redux/orderRedux";

export const addAddressforOrder = async (obj) => {
  // console.log(obj, 'obj')
  return await userRequest.post(
    `${BASE_URL}shippingAddress/addnewAddress`,
    obj
  );
};

export const getNewOrder = async (obj) => {
  console.log(obj, "obj");
  return await userRequest.post(`${BASE_URL}orders/newOrder`, obj);
};

export const getUserOrders = async (dispatch, userId) => {
  try {
    dispatch(getOrderStart());
    const res = await userRequest.get(`${BASE_URL}orders/find/${userId}`);
    dispatch(getOrderSuccess(res.data));
  } catch (err) {
    console.log(err, "err at all orders");
    dispatch(getOrderFailure());
  }
};

export const cancelOrderRequest = async (id, status) => {
  return await userRequest.post(`${BASE_URL}orders/updateStatus/${id}`, status);
};
